import type { TextProps } from 'react-native'
import * as Comp from './bottom-sheets-title.styles'

export const BottomSheetsTitle = ({ children }: TextProps) => {
  return <Comp.Title numberOfLines={2}>{children}</Comp.Title>
}
